import { render, staticRenderFns } from "./MenuCard.vue?vue&type=template&id=f44ccf58&scoped=true&"
import script from "./MenuCard.vue?vue&type=script&lang=js&"
export * from "./MenuCard.vue?vue&type=script&lang=js&"
import style0 from "./MenuCard.vue?vue&type=style&index=0&id=f44ccf58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f44ccf58",
  null
  
)

export default component.exports